export default {
    items: [

        {
            title: true,
            name: 'Módulos',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },
        {
            name: 'Administración',
            url: '/base',
            icon: 'icon-puzzle',
            children: [
                {
                    name: 'Usuarios',
                    url: '/admin/user/list',
                    permission: 'USER_LIST',
                },
                {
                    name: 'Roles',
                    url: '/admin/roles/list',
                    permission: 'ROLE_LIST',
                },
                {
                    name: 'Sedes',
                    url: '/admin/headquarters/list',
                    permission: 'HEADQUARTERS_LIST',
                },
                {
                    name: 'Entidades Bancarias',
                    url: '/admin/banks/list',
                    permission: 'BANK_LIST',
                },
                {
                    name: 'Departamentos',
                    url: '/admin/departments/list',
                    permission: 'DEPARTMENT_LIST',
                },
                {
                    name: 'Convenios',
                    url: '/admin/agreements/list',
                    permission: 'AGREEMENT_LIST',
                },
                {
                    name: 'Tipos de Cuota',
                    url: '/admin/fee-types/list',
                    permission: 'FEE_TYPE_LIST',
                },
                {
                    name: 'Proyectos Asociados',
                    url: '/admin/associated-projects/list',
                    permission: 'ASSOCIATED_PROJECT_LIST',
                },
                {
                    name: 'Documentos',
                    url: '/admin/documents/list',
                    permission: 'DOCUMENT_LIST',
                },
                {
                    name: 'Parámetros',
                    url: '/admin/parameters/general',
                    permission: 'PARAMETER_LIST',
                }
            ]
        },
        {
            name: 'Asesoría',
            url: '/base',
            icon: 'icon-speech',
            children: [
                {
                    name: 'Nueva Consulta',
                    url: '/queries/add',
                    permission: 'QUERY_NEW',
                },
                {
                    name: 'Consultas',
                    url: '/queries/list',
                    permission: 'QUERY_LIST',
                },
                {
                    name: 'Informe Diario',
                    url: '/queries/report',
                    permission: 'QUERY_ADVISER_REPORT',
                },
                {
                    name: 'Categorías',
                    url: '/queries/categories/list',
                    permission: 'QUERY_CATEGORY_LIST',
                },
                {
                    name: 'Tipos Incidencias',
                    url: '/queries/issue-types/list',
                    permission: 'QUERY_ISSUE_TYPE_LIST',
                },
                {
                    name: 'Tipos Respuestas',
                    url: '/queries/answer-types/list',
                    permission: 'QUERY_ANSWER_TYPE_LIST',
                },
                {
                    name: 'Encuestas',
                    url: '/queries/ratings/list',
                    permission: 'QUERY_RATING_LIST',
                }
            ],
        },
        {
            name: 'Socios',
            url: '/base',
            icon: 'icon-people',
            children: [
                {
                    name: 'Agregar Socio',
                    url: '/partners/accounts/add',
                    permissions: ['REGISTER_MEMBER']
                },
                {
                    name: 'Listado de Socios',
                    url: '/partners/accounts/list',
                    permission: 'MEMBER_LIST',
                },
                {
                    name: 'Listado de No Socios',
                    url: '/partners/no-accounts/list',
                    permission: 'MEMBER_LIST',
                },
                {
                    name: 'Busqueda Avanzada',
                    url: '/partners/accounts/search',
                    permission: 'MEMBER_SEARCH',
                },
                {
                    name: 'Motivos de baja',
                    url: '/partners/unsubscribes/list',
                    permission: 'UNSUBSCRIBE_REASON_LIST',
                },
                {
                    name: 'CNAE',
                    url: '/partners/CNAE/list',
                    permission: 'CNAE_LIST',
                },
            ]
        },
        {
            name: 'Contabilidad',
            url: '/base',
            icon: 'icon-calculator',
            children: [
                {
                    name: 'Nueva Remesa',
                    url: '/accounting/consignments/add',
                    permission: 'CONSIGNMENT_NEW',
                },
                {
                    name: 'Remesas',
                    url: '/accounting/consignments/list',
                    permission: 'CONSIGNMENT_LIST',
                },
                {
                    name: 'Recibos',
                    url: '/accounting/receipts/list',
                    permission: 'RECEIPT_LIST',
                },
                {
                    name: 'Devoluciones',
                    url: '/accounting/bank-returns/list',
                    permission: 'BANK_RETURN_LIST',
                },
                {
                    name: 'Motivos',
                    url: '/accounting/refunds/list',
                    permission: 'DOCUMENT_LIST',
                },
            ]
        },
        {
            name: 'Estadísticas',
            url: '/base',
            icon: 'icon-chart',
            children: [
                {
                    name: 'Cuadro Contable',
                    url: '/statistics/accounting-table',
                    permission: 'ACCOUNTING_TABLE_LIST',
                }
            ]
        },
        {
            name: 'Búsquedas',
            url: '/base',
            icon: 'icon-magnifier',
            children: [
               {
                    name: 'Nueva Búsquedas',
                    url: '/search/add',
                    permission: 'SEARCH_NEW',
                },
                {
                    name: 'Listado de Búsquedas',
                    url: '/search/list',
                    permission: 'SEARCH_LIST',
                }
            ]
        },
        {
            name: 'Comunicaciones',
            url: '/base',
            icon: 'icon-envelope',
            children: [
                {
                    name: 'Contactos',
                    url: '/communications/contacts/list',
                    permission: 'CONTACT_LIST',
                },
                {
                    name: 'Listas de Distribución',
                    url: '/communications/distribution-list/list',
                    permission: 'DISTRIBUTION_LIST_LIST',
                },
                {
                  name: 'Campañas',
                  url: '/communications/campaign/list',
                  permission: 'CAMPAIGN_LIST',
                },
                {
                  name: 'Estadísticas',
                  url: '/communications/statistics/statistics',
                  permission: 'CAMPAIGN_LIST',
                }
            ]
        }
    ]
}
